import { Component, OnInit } from '@angular/core';
import { PopupDetalhesPedidoService } from './popup-detalhes-pedido.service';
import { TruncatePipe } from '../shared/truncate.pipe';
import { NgIf, NgFor } from '@angular/common';

@Component({
    selector: 'app-popup-detalhes-pedido',
    templateUrl: './popup-detalhes-pedido.component.html',
    styleUrls: ['./popup-detalhes-pedido.component.css'],
    standalone: true,
    imports: [NgIf, NgFor, TruncatePipe]
})
export class PopupDetalhesPedidoComponent implements OnInit {

  constructor(public detalhesPedidoService: PopupDetalhesPedidoService) { }

  ngOnInit(): void {
  }

  fecharModal(){
    this.detalhesPedidoService.mostrarPopDetalhesPedido = false;
  }
}